"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var interfaces_1 = require("../interfaces");
var utils_1 = require("../utils");
var Icons_1 = __importDefault(require("./Icons"));
var SearchableSelect = /** @class */ (function (_super) {
    __extends(SearchableSelect, _super);
    function SearchableSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchQuery: '',
            onlyPopular: true,
        };
        _this.toggleIsOpened = _this.toggleIsOpened.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.togglePopular = _this.togglePopular.bind(_this);
        return _this;
    }
    SearchableSelect.prototype.togglePopular = function () {
        this.setState({
            onlyPopular: !this.state.onlyPopular,
        });
    };
    SearchableSelect.prototype.onSearch = function (_a) {
        var value = _a.target.value;
        this.setState({
            searchQuery: value,
        });
    };
    SearchableSelect.prototype.toggleIsOpened = function () {
        if (!this.props.canBeOpened) {
            return;
        }
        this.props.toggle();
    };
    SearchableSelect.prototype.render = function () {
        var _a = this.props, value = _a.value, label = _a.label, options = _a.options, onChange = _a.onChange, canBeOpened = _a.canBeOpened, isVisible = _a.isVisible, isOpened = _a.isOpened, suzukiFirst = _a.suzukiFirst;
        var _b = this.state, searchQuery = _b.searchQuery, onlyPopular = _b.onlyPopular;
        var selected = options.filter(function (o) { return o.id === value; })[0];
        var filteredOptions = options;
        if (onlyPopular) {
            filteredOptions = filteredOptions.filter(function (o) { return o.is_popular; });
        }
        if (!!searchQuery) {
            filteredOptions = options.filter(function (o) { return (o.title.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1); });
        }
        if (!!suzukiFirst) {
            filteredOptions = utils_1.moveToStart(filteredOptions, filteredOptions.findIndex(function (_a) {
                var id = _a.id;
                return id === interfaces_1.VehicleBrands.suzuki;
            }));
        }
        if (!isVisible) {
            return null;
        }
        return (React.createElement("div", { className: "tradein-estimate__collapse-item " + (isOpened && canBeOpened ? 'tradein-estimate__collapse-item_opened' : '') },
            React.createElement("div", { className: "tradein-estimate__collapse-header", onClick: this.toggleIsOpened },
                React.createElement("div", { className: "tradein-estimate__collapse-title" }, label),
                React.createElement("div", { className: "tradein-estimate__collapse-value" }, !!selected ? selected.title : '')),
            React.createElement("div", { className: "tradein-estimate__collapse-body" },
                React.createElement("div", { className: "tradein-estimate__input" },
                    React.createElement("input", { onChange: this.onSearch, value: searchQuery || '', type: "text", placeholder: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0432\u0432\u043E\u0434" })),
                React.createElement("ul", { className: "tradein-estimate__collapse-list" },
                    filteredOptions.map(function (option) { return (React.createElement("li", { key: option.id, onClick: function () { return onChange(option.id); }, className: "tradein-estimate__collapse-list-item " + (option.id === value ? 'tradein-estimate__collapse-list-item_active' : '') },
                        React.createElement("span", null, option.title),
                        option.id === interfaces_1.VehicleBrands.suzuki && (React.createElement(Icons_1.default.SuzukiLogo, { className: "tradein-estimate__collapse-list-item-icon", width: "24", height: "25" })))); }),
                    !searchQuery ? (React.createElement("li", { style: { color: '#27509B', cursor: 'pointer', fontWeight: 'bold' }, className: 'tradein-estimate__collapse-list-item', onClick: this.togglePopular },
                        React.createElement("span", null, onlyPopular ? 'Все марки' : 'Только популярные'))) : null))));
    };
    SearchableSelect.defaultProps = {
        options: [],
        canBeOpened: false,
    };
    return SearchableSelect;
}(React.PureComponent));
exports.default = SearchableSelect;
